import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchSalesforceIntegration } from "./api"

export function useFetchSalesforceIntegration() {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["salesforce-integration"],
    queryFn: async () => {
      const context = await getContext()
      return fetchSalesforceIntegration(context)
    },
  })
}
